import { useGlobalContext } from "../../../../../Context/Context";
import { useEffect, useState } from "react";
import axios from "axios";

const cs = {
  border: "1px solid black",
  padding: "4px",
  textAlign: "center",
  verticalAlign: "middle",
  fontSize: "12px",
};

const tipLabel = { PRETHODNI: "Претходни", PERIODICNI: "Периодични", CILJANI: "Циљани" };

// group = niz redova za jednog zaposlenog (razliciti tipovi pregleda)
function Obrazac5Prikaz({ group }) {
  const { selectedMainEntity } = useGlobalContext();
  const first = group[0];

  const prethodni = group.filter(r => r.tip_pregleda === "PRETHODNI");
  const periodicni = group.filter(r => r.tip_pregleda === "PERIODICNI");
  const ciljani = group.filter(r => r.tip_pregleda === "CILJANI");

  const buildRows = () => {
    const rows = [];
    prethodni.forEach(r => rows.push({ ...r, labelRowspan: 1, showLabel: true }));
    periodicni.forEach((r, idx) => rows.push({ ...r, labelRowspan: periodicni.length, showLabel: idx === 0 }));
    ciljani.forEach((r, idx) => rows.push({ ...r, labelRowspan: ciljani.length, showLabel: idx === 0 }));
    return rows;
  };

  const rows = buildRows();

  const { baseUrl, loggedUser, apiKey } = useGlobalContext();
const [header, setHeader] = useState({ name: "", address: "", pib: "" });

useEffect(() => {
  const fetchHeader = async () => {
    const id = selectedMainEntity?.company_id || selectedMainEntity?.id;
    if (!id || !loggedUser?.id) return;
    try {
      const { data: res } = await axios.post(`${baseUrl}/companies/readCompanyDetails.php`, {
        user_id: loggedUser.id,
        api_key: apiKey,
        company_id: id,
      });
      if (res.status === 200) setHeader({
        name: res.data.company_name,
        address: res.data.company_address, // Proveri da li je u PHP-u 'company_address'
        pib: res.data.pib
      });
    } catch (e) { console.error(e); }
  };
  fetchHeader();
}, [selectedMainEntity, loggedUser?.id]);

  return (
    <>
      <div style={{ fontWeight: "bold", textAlign: "center", marginBottom: "20px" }}>
        <div>Образац 5</div>
        <div>ЕВИДЕНЦИЈА О ЗАПОСЛЕНИМА КОЈИ СУ ИЗЛОЖЕНИ КАРЦИНОГЕНИМА ИЛИ МУТАГЕНИМА, ХЕМИЈСКИМ МАТЕРИЈАМА И АЗБЕСТУ, КАО И О ЗДРАВСТВЕНОМ СТАЊУ И ИЗЛОЖЕНОСТИ</div>
      </div>

       <div style={{ display: "flex" }}>
        <div style={{ width: "33%", textAlign: "center", marginBottom: "10px" }}>
          {header.name}
          <hr style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }} />
          Пословно име послодавца
        </div>
        <div style={{ width: "33%", textAlign: "center" }}>
          {header.address}
          <hr style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }} />
          Адреса седишта послодавца 
        </div>
        <div style={{ width: "33%", textAlign: "center" }}>
          {header.pib}
          <hr style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }} />
          ПИБ послодавца
        </div>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={cs}>Редни број</th>
            <th style={cs}>Назив карциногена или мутагена, хемијске материје и азбеста</th>
            <th style={cs}>CAS број</th>
            <th style={cs}>ES број</th>
            <th style={cs}>Класа опасности</th>
            <th style={cs}>Ime и презиме запосленог</th>
            <th style={cs}>Назив радног места</th>
            <th colSpan={2} style={cs}>Датум извршеног претходног и периодичног лекарског прегледа</th>
            <th style={cs}>Датум следећег прегледа</th>
            <th style={cs}>Број лекарског извештаја</th>
            <th style={cs}>Промена здравственог стања</th>
            <th style={cs}>Изложеност</th>
            <th style={cs}>Напомена</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr key={row.id}>
              {ri === 0 && (
                <>
                  <td style={cs} rowSpan={rows.length}>1.</td>
                  <td style={cs} rowSpan={rows.length}>{first.naziv}</td>
                  <td style={cs} rowSpan={rows.length}>{first.id_broj === "CAS BROJ" ? first.broj : ""}</td>
                  <td style={cs} rowSpan={rows.length}>{first.id_broj === "ES BROJ" ? first.broj : ""}</td>
                  <td style={cs} rowSpan={rows.length}>{first.klasa}</td>
                  <td style={cs} rowSpan={rows.length}>{first.ime_prezime}</td>
                  <td style={cs} rowSpan={rows.length}>{first.workplace_name}</td>
                </>
              )}
              {row.showLabel && (
                <td style={cs} rowSpan={row.labelRowspan}>
                  {tipLabel[row.tip_pregleda] || row.tip_pregleda}
                </td>
              )}
              <td style={cs}>{row.datum_pregleda}</td>
              <td style={cs}>{row.datum_sledeci}</td>
              <td style={cs}>{row.broj_izvestaja}</td>
              <td style={cs}>{row.promena}</td>
              {ri === 0 && (
                <>
                  <td style={cs} rowSpan={rows.length}>{first.izlozenost}</td>
                  <td style={cs} rowSpan={rows.length}>{first.napomena}</td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      <br /><br />
      <div style={{ display: "flex" }}>
        <div style={{ width: "70%", textAlign: "center" }}>
          <hr style={{ width: "80%", margin: "0 auto 5px" }} />
          Саветник/сарадник за безбедност и здравље на раду
        </div>
        <div style={{ width: "30%", textAlign: "center" }}>
          <hr style={{ width: "80%", margin: "0 auto 5px" }} />
          Послодавац
        </div>
      </div>
    </>
  );
}

export default Obrazac5Prikaz;